import { z } from "zod";



export type UserInfoSchema = {
  Id:  string,
  UserName: string,
  FirstName:  string,
  LastName: string,
  RoleIdentifier: string,
  AllowTalkrequest: boolean,
  Presenter:string
 

}



export const UserSchema = z.object({
  Id: z.string().uuid().optional(),
  UserName: z.string().nullable().optional(),
  FirstName: z.string().nullable().optional(),
  LastName: z.string().nullable().optional(),
  Password: z.string().nullable().optional(),
  RoleIdentifier: z.string().nullable().optional(),
  AllowTalkrequest: z.boolean().nullable().optional(),
  IsPresenter: z.boolean().default(true),
})